import { useTranslate } from "#src/hooks";
import { CameraIcon, ImageIcon } from "@phosphor-icons/react";
import { Button, Flex } from "antd";
import { useRef } from "react";
import { StepHeader } from "./StepHeader";

enum CLONING_BUTTON_KEYS {
  CAMERA = "camera",
  LIBRARY = "library",
}

export const PhotoSourceStep = ({
  onCameraSelect,
  onLibrarySelect,
  onFileSelect,
}: {
  onCameraSelect: () => void;
  onLibrarySelect: () => void;
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const t = useTranslate();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFileSelect(event);
    onLibrarySelect();
  };

  const handleLibraryClick = () => {
    if (fileInputRef.current) {
      // Try multiple approaches for Safari compatibility
      try {
        fileInputRef.current.focus();
        fileInputRef.current.click();
      } catch (error) {
        console.error("File input click failed:", error);
        // Fallback: create and dispatch a synthetic event
        const event = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        fileInputRef.current.dispatchEvent(event);
      }
    }
  };
  const cloningButtons = {
    camera: {
      key: CLONING_BUTTON_KEYS.CAMERA,
      icon: <CameraIcon size={32} />,
      action: onCameraSelect,
    },
    library: {
      key: CLONING_BUTTON_KEYS.LIBRARY,
      icon: <ImageIcon size={32} />,
      action: handleLibraryClick,
    },
  };

  return (
    <>
      <StepHeader
        title={t("src.components.ContactCloningMobile.photoSource.title")}
        description={t(
          "src.components.ContactCloningMobile.photoSource.description"
        )}
      />
      <Flex vertical gap={40} style={{ alignSelf: "stretch", padding: 15 }}>
        {Object.values(CLONING_BUTTON_KEYS).map((key) => (
          <Button
            key={key}
            onClick={cloningButtons[key].action}
            size="large"
            type="primary"
            icon={cloningButtons[key].icon}
            style={{ height: 65, fontSize: 18, fontWeight: 500 }}
          >
            {t(`src.components.ContactCloningMobile.photoSource.${key}`)}
          </Button>
        ))}
      </Flex>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileSelect}
        onClick={(e) => {
          // Prevent event bubbling and ensure input is properly focused
          e.stopPropagation();
        }}
      />
    </>
  );
};
